module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lms-b-table"
  }, [_c('el-table', {
    ref: "baseTable",
    attrs: {
      "data": _vm.dataSource,
      "size": _vm.size,
      "stripe": "",
      "size": "small",
      "border": "",
      "default-sort": _vm.defaultSort
    },
    on: {
      "selection-change": _vm.handleSelectionChange,
      "sort-change": _vm.handleSort,
      "row-click": _vm.handleRowClick,
      "row-dblclick": _vm.handleRowDbClick
    }
  }, [(_vm.singleType) ? _c('el-table-column', {
    attrs: {
      "label": "",
      "width": _vm.getWidthByText(_vm.singleSelectText)
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_c('i', {
          class: _vm.singleSelectTypeIcon
        }), _vm._v("\n          " + _vm._s(_vm.singleSelectText) + "\n        ")])]
      }
    }], null, false, 3726283356)
  }) : _vm._e(), _vm._v(" "), (_vm.multipleType) ? _c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": 60
    }
  }) : _vm._e(), _vm._v(" "), (_vm.actionType) ? _c('el-table-column', {
    attrs: {
      "width": 80,
      "fixed": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('dropdown', {
          attrs: {
            "trigger": "click",
            "transfer": ""
          }
        }, [_c('a', {
          attrs: {
            "href": "javascript:void(0)"
          }
        }, [_vm._v("\n            " + _vm._s(_vm.l("CAOZUO")) + "\n            "), _c('i', {
          staticClass: "el-icon-caret-bottom el-icon--right"
        })]), _vm._v(" "), _c('dropdown-menu', {
          attrs: {
            "slot": "list"
          },
          slot: "list"
        }, _vm._l((_vm.actionCol.actions), function(act) {
          return (!act.visible || act.visible(scope.row)) ? _c('dropdown-item', {
            key: act.actionId,
            attrs: {
              "name": act.actionId,
              "placement": "right-end"
            }
          }, [(!act.workflowBusinessType) ? _c('i-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleCommand(act.actionId, scope.row)
              }
            }
          }, [_c('i', {
            class: act.icon
          }), _vm._v(" " + _vm._s(act.display) + "\n              ")]) : [(act.vIf != undefined ? act.vIf : true) ? _c('workflow-button', {
            attrs: {
              "type": "text",
              "workflowBusinessType": act.workflowBusinessType,
              "businessId": act.businessId(scope.row),
              "onSave": act.onSave,
              "onPublish": act.onPublish,
              "onAuditing": act.onAuditing,
              "onRemoteCompeleted": act.onRemoteCompeleted,
              "size": "small"
            }
          }, [(act.icon) ? _c('i', {
            class: act.icon
          }) : _vm._e(), _vm._v("\n                  " + _vm._s(act.display) + "\n                ")]) : _vm._e()]], 2) : _vm._e()
        }), 1)], 1)]
      }
    }], null, false, 3847094824)
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.realCols), function(col) {
    return [(col.render) ? _c('el-table-column', {
      key: col.prop,
      attrs: {
        "prop": col.prop,
        "label": col.label,
        "width": col.width,
        "min-width": col.minWidth,
        "sortable": col.sortable,
        "formatter": col.formatter,
        "align": col.align,
        "sortOrders": ['ascending', 'descending'],
        "show-overflow-tooltip": col.showOverflowTooltip
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('render-cell', {
            attrs: {
              "row": scope.row,
              "index": scope.$index,
              "column": scope.column,
              "render": col.render
            }
          })]
        }
      }], null, true)
    }) : _c('el-table-column', {
      key: col.prop,
      attrs: {
        "prop": col.prop,
        "label": col.label,
        "width": col.width,
        "min-width": col.minWidth,
        "sortable": col.sortable,
        "align": col.align,
        "formatter": col.formatter,
        "show-overflow-tooltip": col.showOverflowTooltip
      }
    })]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-684a33ac"}!./src/shared/libs/ClientFramework/packages/basicElement/table/BaseTable.html
// module id = 929
// module chunks = 80